import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { ShadowDOMElement } from "./fields.js";

export class TransformationList extends ShadowDOMElement {
	static className = "TransformationList";
	
	static properties = {
		title: {type: String, attribute: "title"},
		validationRequired: {
			type: Boolean,
			attribute: "validation-required",
			converter: {
				fromAttribute: (value) => value === "false" ? false : true,
				toAttribute: (value) => (value ? "true" : "false"),
			}
		},
		validationText: {type: String, attribute: "validation-text"}
	};

	constructor() {
		super();
		this.personnePhysiqueVisible = false;
		this.personneMoraleVisible = false;
		this.title = "Gérant";
		this.validationRequired = true;
		this.validationText = "Vous devez cocher au moins une modification";
	}

	handlePersonnePhysiqueChange(event) {
		this.personnePhysiqueVisible = event.target.checked;
		this.requestUpdate();

		// If the checkbox is checked, remove all existing validation messages
		if (event.target.checked) {
			this.shadowRoot.querySelectorAll('div[data-validation-for]').forEach(el => el.remove());
		}
	}

	handlePersonneMoraleChange(event) {
		this.personneMoraleVisible = event.target.checked;
		this.requestUpdate();

		// If the checkbox is checked, remove all existing validation messages
		if (event.target.checked) {
			this.shadowRoot.querySelectorAll('div[data-validation-for]').forEach(el => el.remove());
		}
	}

	render() {
    return html`
      <div>
        <title-field label="${this.title}"></title-field>
        <!-- Checkbox for Personne Physique -->
        <checkbox-field
          label="Personne physique"
          id-input="chkPersonnePhysiqueList"
          name="personne_physique_list"
          class="mt-3"
          .checked="${this.personnePhysiqueVisible}"
          @change="${this.handlePersonnePhysiqueChange}"
        ></checkbox-field>
        <!-- Personne Physique List -->
        <personne-physique-list
          style="display: ${this.personnePhysiqueVisible ? "block" : "none"};"
        ></personne-physique-list>
        <!-- Checkbox for Personne Morale -->
        <checkbox-field
          label="Personne morale"
          id-input="chkPersonneMoraleList"
          name="personne_morale_list"
          class="mt-3"
          .checked="${this.personneMoraleVisible}"
          @change="${this.handlePersonneMoraleChange}"
        ></checkbox-field>
        <!-- Personne Morale List -->
        <personne-morale-transformation-list style="display: ${this.personneMoraleVisible ? "block" : "none"};"></personne-morale-list>
      </div>
    `;
	}
	
	// Validation: show messages for each checkbox if none checked; return false in that case.
	validate() {
		// If validation is not required, always return true
		if (!this.validationRequired) {
			return true;
		}

		const checkboxes = this.shadowRoot.querySelectorAll('checkbox-field');

		// remove all existing validation messages first
		this.shadowRoot.querySelectorAll('div[data-validation-for]').forEach(el => el.remove());

		// if any checkbox is checked -> valid
		const anyChecked = Array.from(checkboxes).some(cb => !!cb.checked);
		if (anyChecked) {
			return true;
		}

		// none checked: show message for each checkbox and return false
		checkboxes.forEach(cb => {
			const id = cb.getAttribute('id-input') || cb.id || cb.getAttribute('id') || '';

			const row = document.createElement('div');
			row.className = 'row align-items-center';
			row.setAttribute('data-validation-for', id);

			const colLeft = document.createElement('div');
			colLeft.className = 'col-sm-3';

			const colRight = document.createElement('div');
			colRight.className = 'col-sm-9 text-danger d-flex align-items-center';
			// requested styling: top = 0.25rem, left = 0px, no bottom padding
			colRight.style.paddingTop = '0.25rem';
			colRight.style.paddingLeft = '0px';
			colRight.style.paddingBottom = '0px';

			const icon = document.createElement('i');
			icon.className = 'fa-solid fa-circle-exclamation me-2';
			icon.setAttribute('aria-hidden', 'true');

			const text = document.createElement('span');
			text.textContent = this.validationText;

			colRight.appendChild(icon);
			colRight.appendChild(text);

			row.appendChild(colLeft);
			row.appendChild(colRight);

			if (cb.parentNode) cb.parentNode.insertBefore(row, cb.nextSibling);
		});

		return false;
	}
	
	isTransient (){
		return false;
	}
	
	getValues (){
		return {
			"personnePhysiqueVisible" : this.personnePhysiqueVisible,
			"personneMoraleVisible" : this.personneMoraleVisible,
			... super.getValues ()
		}
	}
	
	setValues (values){
		this.personnePhysiqueVisible = values.personnePhysiqueVisible;
		this.personneMoraleVisible = values.personneMoraleVisible;
		this.requestUpdate ();
		super.setValues (values);
	}
}

customElements.define("transformation-list", TransformationList);
